export default "__VITE_ASSET__87c61ab5__"